/* Noremya - panier (tiroir sur tout le site + page /cart).
   Lit le panier avec /cart.js, l'affiche aux couleurs Noremya, et remplace le panier natif de Dawn
   (notification ou tiroir) : tout ajout au panier ouvre ce tiroir.
   Réglages (textes, bundle, date de fin d'offre, délais) : section « NM Panier » du groupe Header. */
(function () {
  if (window.NMCart) return;
  var R = window.routes || {};
  var URLS = {
    cart: (R.cart_url || '/cart'), add: (R.cart_add_url || '/cart/add'),
    change: (R.cart_change_url || '/cart/change'), root: (R.root_url || '/')
  };
  var CFG = {};
  try { CFG = JSON.parse((document.getElementById('nm-cart-config') || {}).textContent || '{}'); } catch (e) { CFG = {}; }
  var T = Object.assign({
    title: 'Your cart', checkout: 'Secure checkout', cont: 'Continue shopping', subtotal: 'Subtotal',
    savings: 'Bundle savings', shipping: 'Shipping', shipValue: 'Free', total: 'Total', tax: 'Taxes calculated at checkout',
    perkShip: 'Free tracked shipping', perkSave: 'You’re saving', freeBadge: 'FREE', remove: 'Remove',
    upTitle: 'Add 1 more, it’s FREE', upText: 'Buy 1, Get 1 Free is active. Pick a color for your free bracelet.',
    upButton: 'Add my free bracelet', applied: 'Buy 1, Get 1 Free applied', trust1: 'Free tracked shipping',
    trust2: '30-day money-back guarantee', trust3: 'Secure SSL checkout', eta: 'Estimated delivery:',
    emptyTitle: 'Your cart is empty', emptyText: 'Little lifts are waiting for you.', emptyButton: 'Discover the bracelet',
    timerLabel: 'Buy 1, Get 1 Free ends in', freeTag: 'Free bracelet', bannerOdd: 'Add 1 more bracelet, it’s FREE', secureTitle: '100% secure checkout', saveLabel: 'You save', error: 'Something went wrong. Please try again.'
  }, CFG.texts || {});
  var BUNDLE = CFG.bundle && CFG.bundle.enabled && CFG.bundle.productId ? CFG.bundle : null;

  /* ---------- Outils ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function num(c, d, ts, ds) { var p = (c / 100).toFixed(d).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (p[1] ? ds + p[1] : ''); }
  function money(c) {
    var f = String(CFG.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return num(c, 0, ',', '.');
        case 'amount_with_comma_separator': return num(c, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(c, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(c, 2, "'", '.');
        default: return num(c, 2, ',', '.');
      }
    });
  }
  function img(u, w) { if (!u) return ''; try { var x = new URL(u, location.origin); x.searchParams.set('width', w); return x.toString(); } catch (e) { return u; } }
  function swatch(title) {
    var cord = String(title).split(' & ')[0], c1 = { 'Black': '#1F1F22', 'Pink': '#F3B9C8', 'White': '#FFFFFF', 'Dark Green': '#1F4A36', 'Baby Blue': '#93C9EA' }[cord] || '#D9D6D0';
    var c2 = /gold/i.test(title) ? '#D4AF5A' : '#C3C8CE';
    return '--c1:' + c1 + ';--c2:' + c2;
  }
  var I = {
    close: '<svg class="nmc-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    minus: '<svg class="nmc-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"/></svg>',
    plus: '<svg class="nmc-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    gift: '<svg class="nmc-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12v8H4v-8"/><path d="M2 7h20v5H2z"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7Z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7Z"/></svg>',
    truck: '<svg class="nmc-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v10H3z"/><path d="M14 9h4l3 3.5V16h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>',
    shield: '<svg class="nmc-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v6c0 4.5-3 7.6-7 9-4-1.4-7-4.5-7-9V6l7-3Z"/><path d="m9 12 2 2 4-4"/></svg>',
    lock: '<svg class="nmc-ico" viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10" width="14" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>',
    check: '<svg class="nmc-ico" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="m8 12 3 3 5-6"/></svg>',
    clock: '<svg class="nmc-ico" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2.5 2.5M9 2h6"/></svg>',
    trash: '<svg class="nmc-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>',
    arch: '<svg class="nmc-head__arch" viewBox="0 0 58 66" aria-hidden="true"><circle cx="29" cy="40" r="8.5" fill="#F28C5B"/><path d="M7 64V29a22 22 0 0 1 44 0v35" fill="none" stroke="#1E2440" stroke-width="9" stroke-linecap="round"/></svg>'
  };
  function payIcons() { var t = document.getElementById('nm-cart-pay'); return t ? t.innerHTML.trim() : ''; }

  /* ---------- Panier ---------- */
  var state = { cart: null, busy: false, pick: null };
  function fetchCart() { return fetch(URLS.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(url, body) {
    return fetch(url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || T.error); return j; }); });
  }
  function updateBubble() {
    var b = document.getElementById('cart-icon-bubble'); if (!b) return;
    fetch(URLS.root.replace(/\/?$/, '/') + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var h = s && s['cart-icon-bubble']; if (!h) return;
      var el = new DOMParser().parseFromString(h, 'text/html').querySelector('.shopify-section');
      if (el) b.innerHTML = el.innerHTML;
    }).catch(function () {});
  }
  function freeUnits(it) {
    var d = (it.line_level_discount_allocations || []).reduce(function (a, x) { return a + x.amount; }, 0);
    return it.price > 0 ? Math.round(d / it.price) : 0;
  }
  function discountTitles(cart) {
    var t = [];
    cart.items.forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { var n = a.discount_application && a.discount_application.title; if (n && t.indexOf(n) < 0) t.push(n); }); });
    (cart.cart_level_discount_applications || []).forEach(function (a) { if (a.title && t.indexOf(a.title) < 0) t.push(a.title); });
    return t;
  }
  function bundleQty(cart) { if (!BUNDLE) return 0; return cart.items.reduce(function (a, it) { return a + (it.product_id === BUNDLE.productId ? it.quantity : 0); }, 0); }

  /* ---------- Rendu ---------- */
  function rTimer() {
    var end = CFG.timerEnd ? new Date(CFG.timerEnd) : null;
    if (!end || isNaN(end) || end <= new Date()) return '';
    return '<div class="nmc-timer" data-nmc-timer data-end="' + end.getTime() + '"><span class="nmc-timer__lbl">' + I.clock + esc(T.timerLabel) + '</span><span class="nmc-timer__clock" data-clock></span></div>';
  }
  function rPerks(cart) {
    var h = '<div class="nmc-perks"><span class="nmc-perk">' + I.check + esc(T.perkShip) + '</span>';
    if (cart.total_discount > 0) h += '<span class="nmc-perk nmc-perk--gift">' + I.gift + esc(T.perkSave) + ' ' + money(cart.total_discount) + '</span>';
    return h + '</div>';
  }
  function rItem(it) {
    var fu = freeUnits(it), allFree = it.final_line_price === 0 && it.original_line_price > 0;
    var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(o.value); }).join(' · ');
    var price = (it.final_line_price < it.original_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '') +
      (allFree ? '<strong class="is-free">' + esc(T.freeBadge) + '</strong>' : '<strong>' + money(it.final_line_price) + '</strong>');
    return '<li class="nmc-item' + (fu ? ' is-free' : '') + '" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '">' +
      '<a class="nmc-item__img" href="' + esc(it.url) + '" tabindex="-1">' + (it.image ? '<img src="' + esc(img(it.image, 240)) + '" alt="' + esc(it.product_title) + '" width="120" height="120" loading="lazy">' : '') + '</a>' +
      '<div class="nmc-item__main"><div class="nmc-item__top"><a class="nmc-item__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
      '<button type="button" class="nmc-rm" data-act="rm" aria-label="' + esc(T.remove) + '">' + I.trash + '</button></div>' +
      (opts ? '<p class="nmc-item__var">' + opts + '</p>' : '') +
      (fu ? '<span class="nmc-free">' + I.gift + (allFree ? esc(T.freeTag) : fu + ' ' + esc(T.freeTag)) + '</span>' : '') +
      '<div class="nmc-item__bottom"><div class="nmc-qty"><button type="button" data-act="dec" aria-label="Decrease quantity">' + I.minus + '</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-act="inc" aria-label="Increase quantity">' + I.plus + '</button></div>' +
      '<div class="nmc-item__price">' + price + '</div></div></div></li>';
  }
  function rUpsell(cart) {
    var q = bundleQty(cart); if (!BUNDLE || !q) return '';
    if (q % 2 === 0) return '<div class="nmc-ok">' + I.check + '<span><b>' + esc(T.applied) + '</b> · ' + (q / 2) + ' free bracelet' + (q / 2 > 1 ? 's' : '') + '</span></div>';
    var av = BUNDLE.variants.filter(function (v) { return v.available; }); if (!av.length) return '';
    var inCart = cart.items.map(function (it) { return it.variant_id; });
    if (!state.pick || !av.some(function (v) { return v.id === state.pick; })) {
      var nv = av.filter(function (v) { return inCart.indexOf(v.id) < 0; })[0] || av[0]; state.pick = nv.id;
    }
    var cur = av.filter(function (v) { return v.id === state.pick; })[0];
    var sws = av.map(function (v) { return '<button type="button" class="nmc-sw" role="radio" data-pick="' + v.id + '" aria-checked="' + (v.id === state.pick) + '" aria-label="' + esc(v.title) + '" title="' + esc(v.title) + '" style="' + swatch(v.title) + '"></button>'; }).join('');
    return '<div class="nmc-up"><div class="nmc-up__top"><span class="nmc-up__ico">' + I.gift + '</span><div><p class="nmc-up__t">' + esc(T.upTitle) + '</p><p class="nmc-up__p">' + esc(T.upText) + '</p></div></div>' +
      '<div class="nmc-up__pick"><span class="nmc-up__img">' + (cur.image ? '<img src="' + esc(img(cur.image, 160)) + '" alt="" width="56" height="56">' : '') + '</span><div><div class="nmc-sws" role="radiogroup" aria-label="Free bracelet color">' + sws + '</div><p class="nmc-up__name">' + esc(cur.title) + '</p></div></div>' +
      '<button type="button" class="nmc-up__btn" data-act="addfree">' + I.gift + esc(T.upButton) + ' · <s>' + money(BUNDLE.price) + '</s> <b>' + esc(T.freeBadge) + '</b></button></div>';
  }
  function eta() {
    var a = parseInt(CFG.shipMin, 10), b = parseInt(CFG.shipMax, 10); if (!a || !b) return '';
    function add(n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
    return '<p class="nmc-eta">' + I.truck + '<span>' + esc(T.eta) + ' <b>' + add(a) + ' – ' + add(b) + '</b></span></p>';
  }
  function rRows(cart) {
    var t = discountTitles(cart);
    var h = '<div class="nmc-sum"><div class="nmc-sum__row"><span>' + esc(T.subtotal) + '</span><span>' + money(cart.original_total_price) + '</span></div>';
    if (cart.total_discount > 0) h += '<div class="nmc-sum__row nmc-sum__row--save"><span>' + esc(T.savings) + (t.length ? ' <small style="font-weight:500">(' + esc(t.join(', ')) + ')</small>' : '') + '</span><span>−' + money(cart.total_discount) + '</span></div>';
    return h + '<div class="nmc-sum__row nmc-sum__row--ship"><span>' + esc(T.shipping) + '</span><span>' + esc(T.shipValue) + '</span></div></div>';
  }
  function rTotal(cart) {
    return '<div class="nmc-sum__total"><span>' + esc(T.total) + '</span><strong>' + money(cart.total_price) + '</strong></div><p class="nmc-sum__tax">' + esc(T.tax) + '</p>' +
      '<form action="' + esc(URLS.cart) + '" method="post"><button type="submit" name="checkout" class="nmc-cta">' + I.lock + esc(T.checkout) + ' · ' + money(cart.total_price) + '</button></form>';
  }
  function rPay() { var p = payIcons(); return p ? '<div class="nmc-pay" aria-label="Payment methods">' + p + '</div>' : ''; }
  function rTrust() { return '<ul class="nmc-trust"><li>' + I.truck + esc(T.trust1) + '</li><li>' + I.shield + esc(T.trust2) + '</li><li>' + I.lock + esc(T.trust3) + '</li></ul>' + eta(); }
  /* Page /cart : tout dans la colonne de droite. */
  function rSummary(cart) { return rRows(cart) + rTotal(cart) + rPay() + rTrust(); }
  /* Tiroir : le pied reste court (économies + total + paiement), le détail défile au-dessus. */
  function rBanner(cart) {
    var t = rTimer(); if (t) return t;
    var q = bundleQty(cart); if (!BUNDLE || !q) return '';
    if (q % 2) return '<div class="nmc-banner">' + I.gift + '<span>' + esc(T.bannerOdd) + '</span></div>';
    return '<div class="nmc-banner">' + I.check + '<span>' + esc(T.applied) + ' · ' + (q / 2) + ' free bracelet' + (q / 2 > 1 ? 's' : '') + '</span></div>';
  }
  function rFoot(cart) {
    return '<div class="nmc-secure"><p class="nmc-secure__t">' + I.lock + esc(T.secureTitle) + '</p><p class="nmc-secure__p"><span>✓ ' + esc(T.trust2) + '</span><span>✓ ' + esc(T.trust1) + '</span></p></div>' +
      (cart.total_discount > 0 ? '<div class="nmc-saverow"><span>' + esc(T.saveLabel) + '</span><span>' + money(cart.total_discount) + '</span></div>' : '') +
      '<form action="' + esc(URLS.cart) + '" method="post"><button type="submit" name="checkout" class="nmc-cta">' + esc(T.checkout) + ' · ' + money(cart.total_price) + '</button></form>' + rPay() + eta();
  }
  function rEmpty() {
    return '<div class="nmc-empty"><svg class="nmc-empty__arch" viewBox="0 0 58 66" aria-hidden="true"><defs><clipPath id="nmcClip"><path d="M7 64V29a22 22 0 0 1 44 0v35z"/></clipPath></defs><g clip-path="url(#nmcClip)"><circle class="nmc-empty__sun" cx="29" cy="40" r="8.5" fill="#F28C5B"/></g><path d="M7 64V29a22 22 0 0 1 44 0v35" fill="none" stroke="#1E2440" stroke-width="9" stroke-linecap="round"/></svg>' +
      '<h3>' + esc(T.emptyTitle) + '</h3><p>' + esc(T.emptyText) + '</p><a href="' + esc(CFG.emptyUrl || '/collections/all') + '">' + esc(T.emptyButton) + '</a></div>';
  }
  function rErr() { return state.err ? '<p class="nmc-err" role="alert">' + esc(state.err) + '</p>' : ''; }

  /* ---------- Vues (tiroir et page) ---------- */
  var drawer = null, page = null, lastFocus = null, timerId = null;
  function render() {
    var cart = state.cart; if (!cart) return;
    if (drawer) {
      drawer.querySelector('[data-nmc-count]').textContent = cart.item_count;
      drawer.querySelector('[data-nmc-count]').hidden = !cart.item_count;
      drawer.querySelector('[data-nmc-timer-slot]').innerHTML = cart.item_count ? rBanner(cart) : '';
      drawer.querySelector('[data-nmc-body]').innerHTML = cart.item_count ? '<ul class="nmc-items">' + cart.items.map(rItem).join('') + '</ul>' + rUpsell(cart).replace(/^<div class="nmc-ok">.*$/, '') + rErr() : rEmpty();
      var f = drawer.querySelector('[data-nmc-foot]'); f.hidden = !cart.item_count; f.innerHTML = cart.item_count ? rFoot(cart) : '';
    }
    if (page) {
      page.innerHTML = cart.item_count
        ? rTimer() + '<div class="nmc-page__grid"><div class="nmc-page__main">' + rPerks(cart) + '<ul class="nmc-items">' + cart.items.map(rItem).join('') + '</ul>' + rUpsell(cart) + rErr() + '</div><aside class="nmc-page__side">' + rSummary(cart) + '</aside></div>'
        : rEmpty();
    }
    tick();
  }
  function tick() {
    clearInterval(timerId);
    var els = document.querySelectorAll('[data-nmc-timer]'); if (!els.length) return;
    function u() {
      els.forEach(function (el) {
        var s = Math.max(0, Math.floor((+el.dataset.end - Date.now()) / 1000));
        if (!s) { el.remove(); return; }
        var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
        function b(v, l) { return '<span class="nmc-timer__u">' + String(v).padStart(2, '0') + '<small>' + l + '</small></span>'; }
        el.querySelector('[data-clock]').innerHTML = (d ? b(d, 'days') : '') + b(h, 'hrs') + b(m, 'min') + b(x, 'sec');
      });
    }
    u(); timerId = setInterval(u, 1000);
  }
  function refresh() { return fetchCart().then(function (c) { state.cart = c; state.err = null; render(); return c; }); }
  function setBusy(key) { document.querySelectorAll('.nmc-item[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]').forEach(function (e) { e.classList.add('is-busy'); }); }
  function change(key, qty) {
    setBusy(key);
    return post(URLS.change, { id: key, quantity: qty }).then(function (c) { state.cart = c; state.err = null; render(); updateBubble(); })
      .catch(function (e) { state.err = e.message || T.error; return refresh(); });
  }
  function addFree() {
    if (!state.pick) return;
    var b = document.querySelectorAll('[data-act="addfree"]'); b.forEach(function (x) { x.disabled = true; });
    return post(URLS.add, { items: [{ id: state.pick, quantity: 1 }] }).then(function () { state.pick = null; return refresh(); }).then(updateBubble)
      .catch(function (e) { state.err = e.message || T.error; render(); });
  }
  function onClick(e) {
    var t = e.target.closest('[data-act],[data-pick],[data-nmc-close]'); if (!t) return;
    if (t.hasAttribute('data-nmc-close')) { close(); return; }
    if (t.hasAttribute('data-pick')) { state.pick = +t.dataset.pick; render(); var s = document.querySelector('.nmc-sw[data-pick="' + t.dataset.pick + '"]'); if (s) s.focus(); return; }
    var li = t.closest('.nmc-item'), a = t.dataset.act;
    if (a === 'addfree') { addFree(); return; }
    if (!li) return;
    var q = +li.dataset.qty;
    if (a === 'inc') change(li.dataset.key, q + 1);
    else if (a === 'dec') change(li.dataset.key, Math.max(0, q - 1));
    else if (a === 'rm') change(li.dataset.key, 0);
  }

  /* ---------- Ouverture / fermeture du tiroir ---------- */
  function focusables() { return [].slice.call(drawer.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function (el) { return el.offsetParent !== null; }); }
  function open() {
    if (!drawer) { location.href = URLS.cart; return; }
    if (drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('nmc-lock');
    setTimeout(function () { drawer.querySelector('.nmc-panel').focus(); }, 60);
  }
  function close() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('nmc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function openFresh() { return refresh().then(open); }

  function init() {
    drawer = document.getElementById('NmCartDrawer');
    page = document.querySelector('[data-nmc-page-root]');
    var onCartPage = !!page;
    if (drawer) {
      if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
      drawer.addEventListener('click', onClick);
      drawer.querySelector('.nmc-overlay').addEventListener('click', close);
      drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); return; }
        if (e.key !== 'Tab') return;
        var f = focusables(); if (!f.length) return;
        if (e.shiftKey && (document.activeElement === f[0] || document.activeElement === drawer.querySelector('.nmc-panel'))) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
    }
    if (drawer) {
      // Glisser le panneau vers la droite pour le fermer (mobile).
      var panel = drawer.querySelector('.nmc-panel'), x0 = null, y0 = 0, dx = 0, horiz = null;
      panel.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = 0; horiz = null; }, { passive: true });
      panel.addEventListener('touchmove', function (e) {
        if (x0 === null) return;
        var mx = e.touches[0].clientX - x0, my = e.touches[0].clientY - y0;
        if (horiz === null && (Math.abs(mx) > 8 || Math.abs(my) > 8)) horiz = Math.abs(mx) > Math.abs(my);
        if (!horiz) return;
        dx = Math.max(0, mx); panel.classList.add('is-dragging'); panel.style.transform = 'translateX(' + dx + 'px)';
      }, { passive: true });
      panel.addEventListener('touchend', function () {
        if (x0 === null) return;
        panel.classList.remove('is-dragging'); panel.style.transform = '';
        if (horiz && dx > 80) close();
        x0 = null;
      });
    }
    if (page) page.addEventListener('click', onClick);
    // L'icône panier de l'en-tête ouvre le tiroir (sauf sur la page /cart).
    document.addEventListener('click', function (e) {
      if (onCartPage || !drawer) return;
      var a = e.target.closest('#cart-icon-bubble'); if (!a) return;
      e.preventDefault(); e.stopImmediatePropagation(); openFresh();
    }, true);
    // Le panier natif de Dawn (notification ou tiroir) renvoie vers celui-ci.
    ['cart-notification', 'cart-drawer'].forEach(function (tag) {
      customElements.whenDefined(tag).then(function () {
        var C = customElements.get(tag); if (!C || C.prototype.__nmc) return;
        C.prototype.__nmc = true;
        C.prototype.renderContents = function () { updateBubble(); if (onCartPage) { refresh(); } else { openFresh(); } };
        C.prototype.open = function () { onCartPage ? refresh() : openFresh(); };
      });
    });
    document.addEventListener('nm:cart:open', openFresh);
    if (page || drawer) refresh();
  }
  window.NMCart = { open: openFresh, close: close, refresh: refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
